import { useFetch, useIsLoading } from "../../../Hooks/useFetch";
import EntitySection from "../../Shared/EntitySection/EntitySection";
import {
  expirationColumn,
  idColumn,
  lookupColumn,
  nameColumn,
  textColumn,
} from "../../Shared/TableColumns/tableColumns";
import InventoryElementView from "./InventoryElementView";
import { distinctFilter, expirationFilter, listFilter, selectFilter } from "../../Shared/TableFilters/filterDefs";

import { getAllInventory, deleteInventory } from "../../../Service/InventoryService/InventoryService";
import { useCatalogs } from "../../../Hooks/useCatalogs";

// Licencias y Activos tecnológicos comparten datos (inventario) y se
// distinguen por itemType: "licencia" | "activo"
function Inventory(props: { itemType: "licencia" | "activo" }) {
  const isLicence = props.itemType === "licencia";

  const [allItems, isFetchingItems, updateItems] = useFetch(getAllInventory);
  // Catálogos compartidos con la ficha (caché): no se vuelven a pedir al abrirla
  const { licence = null, partner = null, loading: loadingCatalogs } = useCatalogs(["licence", "partner"]);
  const isLoading = useIsLoading([isFetchingItems]) || loadingCatalogs;

  const rows = (allItems ?? []).filter((item: any) => (isLicence ? item.req_licence === true : item.activo === true));

  // La fecha de vencimiento va siempre en la segunda columna
  const licenceColumns = [
    idColumn(),
    nameColumn("app_name", "Aplicación"),
    expirationColumn(),
    lookupColumn("id_licence", "Tipo de licencia", licence),
  ];

  const activesColumns = [
    idColumn(),
    nameColumn("app_name", "Nombre"),
    expirationColumn(),
    textColumn("departmen", "Dpto. responsable"),
    lookupColumn("id_partner", "Partner", partner),
  ];

  const filters = isLicence
    ? [
        listFilter("licence", "Tipo de licencia", rows, "id_licence", licence),
        expirationFilter(),
        selectFilter(
          "status",
          "Estado",
          [
            { value: "active", label: "Activa" },
            { value: "inactive", label: "Inactiva" },
          ],
          // El formulario guarda el estado en "status"; "active" por compatibilidad
          (row) => ((row.status ?? row.active) ? "active" : "inactive")
        ),
      ]
    : [
        distinctFilter("department", "Dpto. responsable", rows, "departmen"),
        listFilter("partner", "Partner", rows, "id_partner", partner),
        expirationFilter(),
      ];

  return (
    <EntitySection
      filters={filters}
      title={isLicence ? "Licencias" : "Activos tecnológicos"}
      addLabel={isLicence ? "Añadir licencia" : "Añadir activo"}
      type={props.itemType}
      rows={rows}
      loading={isLoading}
      columns={isLicence ? licenceColumns : activesColumns}
      onDelete={(row) => deleteInventory(row)}
      onChanged={updateItems}
      detailTitle={isLicence ? "Información de la Licencia" : "Información del Activo Tecnológico"}
      renderDetail={(row) => <InventoryElementView selectedRow={row} itemType={props.itemType} />}
    />
  );
}

export default Inventory;
